import {Component, Input, OnDestroy} from '@angular/core';
import {SoService, SoType} from '../_services/so.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-sm-icon',
  templateUrl: './sm-icon.component.html',
  styleUrls: ['./sm.component.scss']
})
export class SmIconComponent implements OnDestroy {

  @Input() ttText = '';

  // GENERIC STATE INDICATORS FROM PARENT
  @Input() isActive = false;
  @Input() isDisabled = false;

  // TYPES TO INDICATE WHAT THIS ICON SHOULD DO WHEN CLICKED
  @Input() soType: SoType;

  @Input() withTopMargin = false;

  activeSo: SoType = '';

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private soService: SoService,
  ) {
    this.getSoActive();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private getSoActive(): void {
    this.soService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (so) => {
          this.activeSo = so;
        }
      );
  }

  onClick(): void {
    if (this.soType) {
      this.soService.newSoActive(this.soType);
    }
  }

}
